import { useRef } from 'react';
import { colorState } from '../../Universal/Foundation';
import { Icon } from '../../Universal/NovusDSImports';
import { ClearButton, Input, InputContainer, Prefix, Wrapper } from './styles';

const SearchPhoneNumber = (props: any) => {
  const { searchField, setSearchField } = props;

  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    /* Ensure only digits are kept by removing all non-numeric characters
    (this also prevents users from pasting letters or symbols) */
    const onlyDigits = e.target.value.replace(/\D/g, '');
    setSearchField(onlyDigits);
  };

  const handleClear = () => {
    setSearchField('');
    inputRef.current?.focus();
  };

  return (
    <Wrapper>
      <Prefix id="country-code">+1</Prefix>
      <InputContainer>
        <Icon
          icon={'search'}
          width={16}
          height={16}
          stroke={colorState.icon.default.tertiary}
          aria-hidden="true"
        />

        <Input
          id="phone-number-search-input"
          data-testid="search-input-field"
          ref={inputRef}
          type="search"
          role="searchbox"
          inputMode="numeric"
          pattern="[0-9]*"
          aria-label="Search by phone number"
          aria-describedby="country-code"
          placeholder="Search by Phone No."
          value={searchField}
          onChange={handleChange}
        />

        {searchField && (
          <ClearButton onClick={handleClear} aria-label="Clear search input">
            <Icon
              icon={'close'}
              width={16}
              height={16}
              stroke={colorState.icon.default.tertiary}
              aria-hidden="true"
            />
          </ClearButton>
        )}
      </InputContainer>
    </Wrapper>
  );
};

export default SearchPhoneNumber;
